import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useNavigationIntentStore = defineStore('navigationIntent', () => {
  const intendedRoute = ref<string | null>(null);
  const storageKey = 'navigationIntent';

  function syncToSessionStorage(value: string | null): void {
    try {
      if (value) {
        window.sessionStorage.setItem(storageKey, JSON.stringify({ intendedRoute: value }));
      } else {
        window.sessionStorage.removeItem(storageKey);
      }
    } catch {
      // ignore storage failures (e.g. disabled storage)
    }
  }

  function setIntendedRoute(path: string): void {
    if (!path || path === '/login') {
      return;
    }
    intendedRoute.value = path;
    syncToSessionStorage(intendedRoute.value);
  }

  function clearIntendedRoute(): void {
    intendedRoute.value = null;
    syncToSessionStorage(intendedRoute.value);
  }

  function consumeIntendedRoute(): string | null {
    const path = intendedRoute.value;
    intendedRoute.value = null;
    syncToSessionStorage(intendedRoute.value);
    return path;
  }

  return {
    intendedRoute,
    setIntendedRoute,
    clearIntendedRoute,
    consumeIntendedRoute,
  };
}, {
  persist: {
    key: 'navigationIntent',
    storage: window.sessionStorage,
    pick: ['intendedRoute'],
  },
});
